import React, { useContext, Fragment, useCallback, useMemo } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import { AIChatMessageType, AIChatStatus } from 'app/model/AIChat';

import CustomIconBack from 'app/home/home-components/CustomIconBack';
import { ReactComponent as IconX } from 'images/general/x.svg';

import { ReactComponent as AIMicListening } from 'images/chat/listening.svg';
import { ReactComponent as AIMicThinking } from 'images/chat/thinking.svg';
import { ReactComponent as AIMicIdle } from 'images/chat/idle.svg';
import { ReactComponent as AIMicError } from 'images/chat/error.svg';

import './AIChat.scss'


export default function AIChat({ aiChat, showBackground, blurBackground }) {
    const p = useContext(CurrentPageContext);
    const l = useContext(LocalizationContext);
    const s = l.strings;

    const { startListening, status, messages } = aiChat;

    const onAIChatClick = useCallback(() => {
        if (status === AIChatStatus.idle) {
            startListening(l.language);
        }
    }, [status, startListening, l.language]);

    const [icon, infoText] = useMemo(() => {
        switch (status) {
            case AIChatStatus.listening:
                return [AIMicListening, s.aiChat.listening];
            case AIChatStatus.thinking:
                return [AIMicThinking, s.aiChat.thinking];
            case AIChatStatus.errorNotAllowed:
                return [AIMicError, s.aiChat.errorNotAllowed];
            case AIChatStatus.idle:
            default:
                return [AIMicIdle, s.aiChat.clickToTalk];
        }
    }, [status, s.aiChat]);

    return (
        <div className="ai-chat-page">
            {showBackground ? <Fragment>
                <div className="bg-blank" />
                <div className="bg-secondary-color" />
            </Fragment> : null}
            <div className={"ai-chat-page-content override-view" + (blurBackground ? " blur-background" : "")}>
                <div className="nav-button" onClick={p.dismiss} />
                <div className="header-group">
                    {blurBackground ?
                        <IconX className="x-icon" /> :
                        <CustomIconBack className="back-icon" />}
                    <div />
                </div>

                <div className="messages">
                    {messages.map((message, index) => {
                        if (message.type === AIChatMessageType.userPrompt) {
                            return <div key={`ai-chat-message-${index}`} className="user-prompt">{message.text}</div>;
                        }
                        return null;
                    })}
                </div>

                <div className={"ai-mic " + (status === AIChatStatus.idle ? "idle" : "")} onClick={onAIChatClick}>
                    {React.createElement(icon, { className: "icon" })}
                    <div className="info">{infoText}</div>
                </div>
            </div>
        </div>
    )
}